import type { ReactNode } from "react";

interface SidebarSectionTitleProps {
  children: ReactNode;
}

const SidebarSectionTitle = ({ children }: SidebarSectionTitleProps) => (
  <h2 className="text-grey-600 text-xs">{children}</h2>
);

export default SidebarSectionTitle;
